import React from 'react';
import PropTypes from 'prop-types';
import css from '../DetailsTab.scss';
import TextPreferences from '../TextPreferences';
import TrackingNotifications from './TrackingNotifications';
import StaffEmailPreferences from './StaffEmailPreferences';
import AppointmentPreferences from './AppointmentPreferences';
import SummaryEmailPreferences from "./SummaryEmailPreferences";
import { SFEntityID, StaffNotificationPreferences, StaffProfileData, StaffProfilePrivileges } from 'utils/types';
import { configHasValidHelpDeskKeys } from 'utils/profile';
import { getWord } from 'utils/tenant';

/**
 * @returns {node} the Notifications tab of the staff's profile.
 */
const NotificationDetails = ({
     goToProfileDetails, notificationPreferences, privileges, profile, setValue, supportedCountries, userId
}) => {
    return (
        <div className={css['header-block']}>
            <h1>Notifications</h1>
            <hr className={css['divider']} />
            <div className={css['content-block']}>
                <p>Customize notifications of {getWord('Starfish')} Activity and verify the accuracy of contact information in your profile.</p>
                { privileges.textMessagingEnabled && configHasValidHelpDeskKeys(privileges.helpDeskInformation) &&
                    <TextPreferences isStaff
                                     cellPhone={profile.cellPhone}
                                     goToProfileDetails={goToProfileDetails}
                                     setValue={(newNotificationSettings) => setValue({notificationPreferences: newNotificationSettings})}
                                     supportedCountries={supportedCountries}
                                     textNotificationEnabledForUser={notificationPreferences.textNotificationEnabled} />
                }
                { privileges.allowPreferredEmail &&
                    <StaffEmailPreferences profile={profile}
                                           goToProfileDetails={goToProfileDetails}
                                           setValue={(newProfileSettings) => setValue({userProfile: newProfileSettings})} />
                }
                <h2>Preferences</h2>
                <p>Set preferences for text and email notifications.</p>
                <SummaryEmailPreferences notificationPreferences={notificationPreferences}
                                         setValue={(newNotificationSettings) => setValue({notificationPreferences: newNotificationSettings})}/>
                { privileges.hasConnect &&
                    <AppointmentPreferences notificationPreferences={notificationPreferences}
                                            setValue={(newNotificationSettings) => setValue({notificationPreferences: newNotificationSettings})}
                                            weekendReminderEmailSettingEnabled={privileges.weekendReminderEmailSettingEnabled} />
                }
                <TrackingNotifications canAssignTrackingItems={privileges.canAssignTrackingItems}
                                       hasEarlyAlert={privileges.hasEarlyAlert}
                                       notificationPreferences={notificationPreferences}
                                       setValue={(newNotificationSettings) => setValue({notificationPreferences: newNotificationSettings})}
                                       userId={userId} />
            </div>
        </div>
    );
};

NotificationDetails.propTypes = {
    allowPreferredEmail: PropTypes.bool,
    goToProfileDetails: PropTypes.func.isRequired,
    notificationPreferences: StaffNotificationPreferences,
    privileges: StaffProfilePrivileges,
    profile: StaffProfileData.isRequired,
    setValue: PropTypes.func.isRequired,
    supportedCountries: PropTypes.string,
    userId: SFEntityID.isRequired
};

export default NotificationDetails;
